import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _isEmpty from "lodash/isEmpty";
import React, { useCallback, useContext } from 'react';
import { Impression, ImpressionContext } from '@nerdwallet/analytics/react/impression';
import classes from '@nerdwallet/base-styles/classes';
import { Button, Link, Tooltip, Type } from '@nerdwallet/currency';
import analyticsLib from '@nerdwallet/analytics';
import styles from './marketplace-product-card.module.less';
export var REG_FLOW = 'credit-score';
export var CC_GET_FREE_CS = 'cc_get_free_cs';
export var CC_GET_APPROVAL_ODDS = 'cc_get_approval_odds';
/**
 * Open the nw-auth-dialog with parameterized tracking meta data.
 * @param {object} trk - Any trk params to be sent accompanying tracking & registration events
 */

export var handleAuthClickDefault = function handleAuthClickDefault(trk) {
  var _global, _global$nwapi, _global$nwapi$ui, _global$nwapi$ui$show;

  return (_global = global) === null || _global === void 0 ? void 0 : (_global$nwapi = _global.nwapi) === null || _global$nwapi === void 0 ? void 0 : (_global$nwapi$ui = _global$nwapi.ui) === null || _global$nwapi$ui === void 0 ? void 0 : (_global$nwapi$ui$show = _global$nwapi$ui.showAuthDialog) === null || _global$nwapi$ui$show === void 0 ? void 0 : _global$nwapi$ui$show.call(_global$nwapi$ui, {
    version: 2,
    trk: trk,
    flow: REG_FLOW,
    onSuccess: function onSuccess() {
      var _global$window, _global$window$locati, _global$window$locati2;

      return (_global$window = global.window) === null || _global$window === void 0 ? void 0 : (_global$window$locati = _global$window.location) === null || _global$window$locati === void 0 ? void 0 : (_global$window$locati2 = _global$window$locati.reload) === null || _global$window$locati2 === void 0 ? void 0 : _global$window$locati2.call(_global$window$locati, true);
    }
  });
};

var LoaCtaContent = function LoaCtaContent(_ref) {
  var analytics = _ref.analytics,
      ctaText = _ref.ctaText,
      enableAnalytics = _ref.enableAnalytics,
      isKetoCard = _ref.isKetoCard,
      onClick = _ref.onClick;
  var impressionContext = useContext(ImpressionContext);
  var internalOnclick = useCallback(function () {
    if (analytics !== null && analytics !== void 0 && analytics.enabled || enableAnalytics || !_isEmpty(analytics)) {
      if (impressionContext !== null && impressionContext !== void 0 && impressionContext.impressionId) {
        analyticsLib.track('element_interacted', {
          action: 'open',
          entity_name: CC_GET_APPROVAL_ODDS,
          impression_id: impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId,
          interaction_type: 'press'
        });
      }

      onClick(impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId);
    } else {
      onClick();
    }
  }, [analytics, enableAnalytics, impressionContext, onClick]);

  if (isKetoCard) {
    return /*#__PURE__*/React.createElement(Link, {
      onClick: internalOnclick
    }, /*#__PURE__*/React.createElement(Type, {
      size: "1"
    }, ctaText));
  }

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles['loaCta--wide']
  }, /*#__PURE__*/React.createElement(Link, {
    onClick: internalOnclick
  }, /*#__PURE__*/React.createElement(Type, {
    size: "1"
  }, ctaText))), /*#__PURE__*/React.createElement("div", {
    className: styles['loaCta--mobile']
  }, /*#__PURE__*/React.createElement(Button, {
    className: classes(['background-white', 'width-100']),
    onClick: internalOnclick
  }, ctaText)));
};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  LoaCtaContent.propTypes = {
    analytics: PropTypes.shape({
      entityName: PropTypes.string,
      enabled: PropTypes.bool
    }),
    ctaText: PropTypes.string.isRequired,
    enableAnalytics: PropTypes.bool,
    onClick: PropTypes.func,
    isKetoCard: PropTypes.bool
  };
}

var LikelihoodOfApprovalCTA = function LikelihoodOfApprovalCTA(_ref2) {
  var approvalOddsEnabled = _ref2.approvalOddsEnabled,
      analytics = _ref2.analytics,
      ctaText = _ref2.ctaText,
      enableAnalytics = _ref2.enableAnalytics,
      onClick = _ref2.onClick,
      isKetoCard = _ref2.isKetoCard,
      tooltipLabel = _ref2.tooltipLabel,
      tooltipContent = _ref2.tooltipContent;
  var entityName = approvalOddsEnabled ? CC_GET_APPROVAL_ODDS : CC_GET_FREE_CS;
  return /*#__PURE__*/React.createElement(Impression, {
    component: "span",
    eventType: "registration_cta_impression",
    entityName: entityName,
    enabled: (analytics === null || analytics === void 0 ? void 0 : analytics.enabled) || enableAnalytics || !_isEmpty(analytics),
    payload: {
      additional_attributes: {
        target_flow: REG_FLOW,
        cta_mode: 'modal',
        cta_format: 'link',
        cta_label: ctaText
      },
      element_position: analytics === null || analytics === void 0 ? void 0 : analytics.elementPosition,
      section_name: (analytics === null || analytics === void 0 ? void 0 : analytics.sectionName) || 'likelihood_approval',
      section_position: analytics === null || analytics === void 0 ? void 0 : analytics.sectionPosition
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.loaCtaWrapper
  }, /*#__PURE__*/React.createElement(LoaCtaContent, {
    analytics: analytics,
    ctaText: ctaText,
    enableAnalytics: enableAnalytics,
    isKetoCard: isKetoCard,
    onClick: onClick
  }), !_isEmpty(tooltipLabel) && !_isEmpty(tooltipContent) && /*#__PURE__*/React.createElement(Tooltip, {
    id: "loa-cta-tooltip",
    className: styles.loaTooltip,
    content: /*#__PURE__*/React.createElement("span", {
      className: styles.tooltipContent
    }, tooltipContent),
    title: "More information about ".concat(tooltipLabel),
    placement: "bottom",
    analytics: (enableAnalytics || analytics) && _objectSpread({
      entityNamePrefix: "loa_cta_tooltip"
    }, analytics)
  })));
};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var _PropTypes = require('prop-types');

  LikelihoodOfApprovalCTA.propTypes = {
    approvalOddsEnabled: _PropTypes.bool,
    analytics: _PropTypes.shape({
      elementPosition: _PropTypes.number,
      enabled: _PropTypes.bool,
      entityName: _PropTypes.string,
      sectionName: _PropTypes.string,
      sectionPosition: _PropTypes.number
    }),
    ctaText: _PropTypes.string.isRequired,
    enableAnalytics: _PropTypes.bool,
    onClick: _PropTypes.func,
    isKetoCard: _PropTypes.bool,
    tooltipContent: _PropTypes.element,
    tooltipLabel: _PropTypes.string
  };
}

LikelihoodOfApprovalCTA.defaultProps = {
  approvalOddsEnabled: true,
  analytics: {
    elementPosition: 0,
    sectionPosition: 0
  },
  onClick: function onClick(impressionId) {
    return handleAuthClickDefault({
      navigation_source_impression_id: impressionId
    });
  },
  isKetoCard: false,
  tooltipContent: '',
  tooltipLabel: ''
};
export default LikelihoodOfApprovalCTA;